import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { InputSizes } from '../model/types';
import * as stylex from '@stylexjs/stylex';

type TSizes = {
  small: string;
  medium: string;
  large: string;
};

const sizes: TSizes = {
  small: typography['fontSizeCaption-1'],
  medium: typography['fontSizeBody-3'],
  large: typography['fontSizeBody-2'],
};

export const styles = stylex.create({
  block: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    alignSelf: 'stretch',
  },
  container: {
    position: 'relative',
  },
  base: {
    border: '1px solid',
    borderRadius: anatomy['size-8'],
    paddingLeft: '20px',
    background: colors.primaryBackground,
    color: colors.primaryText,
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    borderColor: colors.tertiaryBorder,
    ':hover': {
      borderColor: colors.hoverBorder,
    },
    ':focus': {
      borderColor: colors.accentBorder,
      outline: 'none',
    },
    userSelect: 'none',
  },
  isDisabled: {
    borderColor: colors.ghostBorder,
    color: colors.ghostText,
    cursor: 'not-allowed',
    ':hover': {
      borderColor: 'none',
    },
  },
  inputText: (isSearch, size: InputSizes) => ({
    paddingRight: '50px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: isSearch ? 'text' : 'pointer',
    fontFamily: fonts.din2014Regular,
    fontSize: sizes[size],
    fontWeight: typography.fontWeighRegular,
    lineHeight:
      size === 'large'
        ? typography['lineHeightBody-2']
        : size === 'medium'
          ? typography['lineHeightBody-4']
          : typography['lineHeightCaption-1'],
  }),
  optionsBlock: {
    paddingTop: '4px',
  },
  arrowIcon: (size, isDisabled) => ({
    position: 'absolute',
    top: size === 'large' ? '16px' : size === 'medium' ? '12px' : '10px',
    right: size === 'large' ? '20px' : size === 'medium' ? '20px' : '16px',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    userSelect: 'none',
  }),
  options: {
    display: 'flex',
    maxHeight: '188px',
    minHeight: '38px',
    border: '1px solid',
    borderRadius: '8px',
    flexDirection: 'column',
    padding: '4px 0',
    gap: '4px',
    borderColor: colors.tertiaryBorder,
    backgroundColor: colors.primaryBackground,
    boxSizing: 'border-box',
  },
  optionsItem: (isSelect, selectType) => ({
    display: 'flex',
    justifyContent: selectType === 'checkbox' ? 'flex-end' : 'space-between',
    flexDirection: selectType === 'checkbox' ? 'row-reverse' : 'row',
    minHeight: '36px',
    paddingLeft: '16px',
    margin: '0 0 0 4px',
    alignItems: 'center',
    fontFamily: fonts.din2014Regular,
    background: isSelect ? '' : '',
    ':hover': {
      background: colors.hoverBackground,
      borderRadius: '4px',
    },
    cursor: 'pointer',
  }),
  optionTitle: {
    fontSize: typography['fontSizeBody-4'],
    color: colors.primaryText,
  },
  optionIcon: {
    paddingRight: '12px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  small: {
    width: '280px',
    height: anatomy['size-36'],
  },
  medium: {
    width: '280px',
    height: anatomy['size-48'],
  },
  large: {
    width: '280px',
    height: '60px',
  },
  aboveDropdown: {
    display: 'flex',
    alignItems: 'center',
    flex: '1 0 0',
  },
  labelMessage: (isDisabled, size) => ({
    fontFamily: fonts.din2014Regular,
    fontSize:
      size === 'small'
        ? typography['fontSizeCaption-2']
        : size === 'medium'
          ? typography['fontSizeCaption-1']
          : typography['fontSizeBody-4'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight:
      size === 'small'
        ? typography['lineHeightCaption-2']
        : size === 'medium'
          ? typography['lineHeightCaption-1']
          : typography['lineHeightBody-4'],
    color: isDisabled ? colors.ghostText : colors.secondaryText,
  }),
  preloader: (size) => ({
    position: 'absolute',
    top: size === 'large' ? '14px' : size === 'medium' ? '12px' : '8px',
    right: size === 'large' ? '20px' : size === 'medium' ? '20px' : '16px',
    cursor: 'not-allowed',
  }),
  optionsItemMissingDisplayedKey: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    minHeight: '36px',
    paddingLeft: '16px',
    margin: '0 0 0 4px',
    alignItems: 'center',
    fontFamily: fonts.din2014Regular,
    ':hover': {
      background: colors.hoverBackground,
      borderRadius: '4px',
    },
    cursor: 'pointer',
  },
  noResultsFound: {
    display: 'flex',
    justifyContent: 'flex-start',
    minHeight: '25px',
    paddingLeft: '20px',
    alignItems: 'center',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    color: colors.secondaryText,
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
});
